<template>
  <div>
    <DeleteJourneyExtraData :selectedExtraData="selectedExtraData"
                            v-model="isDeleteExtraDataDialogOpened"/>
    <JourneyExtraDataCreatorDialog :selectedExtraData="selectedExtraData"
                                   v-model="isCreateExtraDataComponentShown"/>
    <v-card>
      <v-card-text>
        <span class="kbDarkBlue--text text-capitalize"
              style="font-size: 18px">
          {{ $t('general.extraData') }}
        </span>

        <v-list two-line v-if="selectedJourney.extradata &&
                               Array.isArray(selectedJourney.extradata) &&
                               selectedJourney.extradata.length > 0">
          <v-list-item class="kbLight mb-1"
                       :key="index"
                       v-for="(data, index) in selectedJourney.extradata">
            <v-list-item-action>
              <v-icon color="kbDarkBlue" size="28px">
                {{ extraDataTypeInfo(data.type).icon }}
              </v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="kbDarkBlue--text">
                {{ data.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="kbDarkBlue--text font-weight-light">
                {{ extraDataTypeInfo(data.type).text }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="updateExtraData(data)"
                           color="kbDarkBlue"
                           text
                           icon
                           v-on="on">
                      <v-icon size="26px">
                        edit
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="ml-2"
                           @click="deleteExtraData(data)"
                           color="kbDarkBlue"
                           text
                           icon
                           v-on="on">
                      <v-icon size="26px">
                        delete
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn class="mr-1 mb-1"
               color="kbLightBlue"
               dark
               rounded
               @click="createNewExtraData()">
          <v-icon class="mr-2">mdi-plus</v-icon>
          <span>{{ $t('general.add') }} {{ $t('general.extraData') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DeleteJourneyExtraData from '@/pages/App/Journey/dialogs/DeleteJourneyExtraData'
import JourneyExtraDataCreatorDialog from '@/pages/App/Journey/JourneyExtraDataCreatorDialog'
export default {
  components: { DeleteJourneyExtraData, JourneyExtraDataCreatorDialog },
  computed: {
    ...mapState({
      selectedJourney: state => state.journey.selectedJourney
    })
  },
  data () {
    return {
      isCreateExtraDataComponentShown: false,
      isDeleteExtraDataDialogOpened: false,
      selectedExtraData: {}
    }
  },
  methods: {
    clearSelectedExtraData () {
      this.selectedExtraData = {}
    },
    createNewExtraData () {
      this.isCreateExtraDataComponentShown = true
    },
    deleteExtraData (extraData) {
      this.selectedExtraData = extraData
      this.isDeleteExtraDataDialogOpened = true
    },
    extraDataTypeInfo (type) {
      switch (type) {
        case 'text':
          return { text: this.$t('general.extraCreatorShortText'), icon: 'short_text' }
        case 'textLong':
          return { text: this.$t('general.extraCreatorLongText'), icon: 'mdi-text-subject' }
        case 'radio':
          return { text: this.$t('general.extraCreatorRadioList'), icon: 'mdi-radiobox-marked' }
        case 'checkbox':
          return { text: this.$t('general.extraCreatorCheckList'), icon: 'mdi-checkbox-marked' }
        case 'select':
          return { text: this.$t('general.extraCreatorList'), icon: 'arrow_drop_down_circle' }
        default:
          return { text: '', icon: '' }
      }
    },
    updateExtraData (extraData) {
      this.selectedExtraData = extraData
      this.isCreateExtraDataComponentShown = true
    }
  },
  watch: {
    isCreateExtraDataComponentShown (newValue) {
      if (!newValue) this.clearSelectedExtraData()
    },
    isDeleteExtraDataDialogOpened (newValue) {
      if (!newValue) this.clearSelectedExtraData()
    }
  }
}
</script>
